import React, { useState } from 'react'
import { Spinner } from '@telavita-core/react-design-kit'

import { useDaysViewData } from './hooks/useDaysViewData'
import { useHoursViewData } from './hooks/useHoursViewData'

import { GraphicsCard } from 'components/GraphicsCard'
import { ResumeSection } from './components/ResumeSection'
import { GraphicsSection } from './components/GraphicsSection'

import { rangeDateFilterOptions } from 'settings/_filterSettings'

import {
  GraphicsDropdown,
  SelectedDate,
  getRangeDays,
  lastDay
} from 'components/GraphicsDropdown'

import {
  Container,
  Loading,
  Content,
} from './styles'

export function AvailabilitySchedules(): JSX.Element {
  const initialOption = rangeDateFilterOptions[0]
  const [activeTab, setActiveTab] = useState(0)
  const [selectedDate, setSelectedDate] = useState<SelectedDate>({
    initialDate: getRangeDays(initialOption.quantity).toString(),
    endDate: lastDay.toString(),
  })

  const { 
    availabilitySlotsTotal,
    daysViewData, 
    loadingDayGraphic,
    schedulesReceivedTotal
  } = useDaysViewData({ selectedDate })
  const { hoursViewData } = useHoursViewData({ selectedDate })

  function handleChangeTab(_, value: number) {
    setActiveTab(value)
  }

  return (
    <GraphicsCard
      id='sectionSchedulingAvailability'
      title={<>Disponibilidade x<br /> Agendamentos</>}
      headerAction={
        <GraphicsDropdown 
          initialOption={initialOption}
          onSelectedDate={setSelectedDate}
        />
      }
    >
      <Container>
        {loadingDayGraphic && (
          <Loading>
            <Spinner />
          </Loading>
        )}

        <Content isLoading={loadingDayGraphic}>

          <ResumeSection 
            availabilitySlotsTotal={availabilitySlotsTotal}
            schedulesReceivedTotal={schedulesReceivedTotal}
          />

          <GraphicsSection
            daysViewData={daysViewData}
            hoursViewData={hoursViewData}
            activeTab={activeTab}
            handleChangeTab={handleChangeTab}
          />

        </Content>
      </Container>
    </GraphicsCard>
  )
}